import { Calendar } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { DATE_PRESETS } from '@/lib/businessValueApi';

export default function DateRangeFilter({ range, onChange }) {
  const handlePresetChange = (preset) => {
    onChange({ ...range, preset });
  };

  return (
    <div
      className="flex flex-col gap-3 sm:flex-row sm:items-end sm:flex-wrap"
      data-testid="bv-date-filter"
    >
      <div className="flex flex-col gap-1.5">
        <Label
          htmlFor="bv-date-preset"
          className="text-xs text-muted-foreground flex items-center gap-1.5"
        >
          <Calendar className="h-3.5 w-3.5" />
          Date range
        </Label>
        <Select
          value={range.preset || 'last_7_days'}
          onValueChange={handlePresetChange}
        >
          <SelectTrigger id="bv-date-preset" className="w-[220px]" aria-label="Date range">
            <SelectValue placeholder="Select range" />
          </SelectTrigger>
          <SelectContent>
            {DATE_PRESETS.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {range.preset === 'custom' && (
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <Label htmlFor="bv-from-date" className="text-xs">
              From
            </Label>
            <Input
              id="bv-from-date"
              type="date"
              value={range.fromDate || ''}
              onChange={(e) => onChange({ ...range, fromDate: e.target.value })}
              className="w-40"
            />
          </div>
          <div>
            <Label htmlFor="bv-to-date" className="text-xs">
              To
            </Label>
            <Input
              id="bv-to-date"
              type="date"
              value={range.toDate || ''}
              onChange={(e) => onChange({ ...range, toDate: e.target.value })}
              className="w-40"
            />
          </div>
        </div>
      )}
    </div>
  );
}
